import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function CtaSection() {
  const allMovies = movies.slice(0, 8);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="relative rounded-2xl overflow-hidden p-8 md:p-14 text-center">
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-900 to-foreground-950"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="flex flex-wrap gap-2 justify-center">
            {allMovies.map((m) => (
              <span key={m.id} className="text-xs text-background-50/30 whitespace-nowrap px-2">
                {m.title}
              </span>
            ))}
          </div>
        </div>
        <div className="relative z-10">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
            准备好了吗？开始你的观影之旅
          </h2>
          <p className="text-sm md:text-base text-background-50/60 max-w-lg mx-auto mb-8">
            海量高清影视资源，每日更新，流畅播放。加入丁香花影院，随时随地享受极致观影体验。
          </p>
          <Link
            to="/category/action"
            className="inline-flex items-center px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: "oklch(var(--accent-500))", color: "#fff" }}
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始免费观影
          </Link>
        </div>
      </div>
    </section>
  );
}